import { motion, AnimatePresence } from 'framer-motion';
import { forwardRef } from 'react';
import Button from '../../components/ui/Button';

const TaskPanel = forwardRef(function TaskPanel({
  isOpen, tasks, rewardsClaimed, onComplete,
}, ref) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="task-panel"
          className="panel task-panel"
          ref={ref}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.2 }}
        >
          <h3 className="panel-title">Günlük Görev</h3>
          {tasks.length === 0 ? (
            <p className="panel-empty">Henüz görev yok.</p>
          ) : (
            tasks.map((task) => (
              <div key={task.id} className={`panel-task ${task.completed ? 'panel-task--done' : ''}`}>
                <span>{task.description}</span>
                <span className="panel-task-status">
                  {task.completed ? '✅ Tamamlandı' : '⏳ Devam Ediyor'}
                </span>
              </div>
            ))
          )}
          <Button
            variant="primary"
            size="sm"
            onClick={onComplete}
            disabled={rewardsClaimed}
            style={{ width: '100%', marginTop: 'var(--space-3)' }}
          >
            Görevi Tamamladım
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default TaskPanel;
